import { Directive, EventEmitter, inject, Input, OnDestroy, Output, signal } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { OrderState } from './models/order-state.model';
import { ProductsService } from 'app/products/products.service';
import { PriceService } from './price/price.service';
import { InsuranceTypesService } from '@core';

@Directive()
export abstract class OrderStepBaseComponent<T extends Partial<OrderState> = Partial<OrderState>> implements OnDestroy {
    protected priceService = inject(PriceService);
    protected _state = signal<Partial<OrderState>>({});
    protected _isOpen = signal<boolean>(false);
    protected _isFirstStep = signal<boolean>(false);

    protected product = inject(ProductsService).product;
    protected insuranceType = inject(InsuranceTypesService).insuranceType;
    protected price = this.priceService.price;

    @Input()
    public set state(value: Partial<OrderState>) {
        this._state.set(value);
        this.handleStateChange();
    }
    public get state(): Partial<OrderState> {
        return this._state();
    }

    @Input()
    public set isOpen(value: boolean) {
        this._isOpen.set(value);
    }
    public get isOpen(): boolean {
        return this._isOpen();
    }

    @Input()
    public set isFirstStep(value: boolean) {
        this._isFirstStep.set(value);
    }
    public get isFirstStep(): boolean {
        return this._isFirstStep();
    }

    @Output()
    public prev: EventEmitter<Partial<OrderState>> = new EventEmitter<Partial<OrderState>>();
    @Output()
    public next: EventEmitter<Partial<OrderState>> = new EventEmitter<Partial<OrderState>>();

    public form: FormGroup;

    protected unsubscribe$: Subject<void> = new Subject<void>();

    public ngOnDestroy(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    public handleStateChange(): void {}

    public abstract getData(): T;

    public submit(): void {
        this.next.emit(this.getData());
    }

    public btnPrev(): void {
        this.prev.emit(this.isInvalid ? {} : this.getData());
    }

    public get isInvalid(): boolean {
        return this.form?.invalid;
    }
}
